module.exports = __webpack_public_path__ + "static/media/spinn_img.8e9c6f69.gif";